"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "f760ad3",
    "raw": "v3.16.0",
    "semverString": "3.16.0"
};
//# sourceMappingURL=version.js.map